import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import HighchartsVue from 'highcharts-vue'
import VueHtmlToPaper from 'vue-html-to-paper';
import moment from 'moment'

Vue.use(HighchartsVue)
Vue.use(VueHtmlToPaper);
import Vuelidate from 'vuelidate'
import { months } from 'moment';
Vue.use(Vuelidate)
moment.locale("es");

Vue.config.productionTip = false

const heroku = 'https://api-libra.herokuapp.com/api/'
const api_plesk = 'https://api.librarentacar.com/api/'

let back = window.location.host.includes("localhost") ? 'http://localhost:4000/api/' : api_plesk;

axios.defaults.baseURL=back

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
